export const AMOUNTS_FORMATTING_FEATURE_FLAG = 'highlight-amounts-formatting'
export const ordersTableFeatures = {
  // Temporary hide estimated execution price because it requires rework and retest
  DISPLAY_EST_EXECUTION_PRICE: false,
  DISPLAY_EXECUTION_TIME: false,
}

export const ADVANCED_ORDERS_FEATURE_FLAG = 'advanced-orders'
